import styled, { css } from "styled-components";

const StyledDesktopHeader = styled.div`
  width: 100%;
  height: auto; //100px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 40;
  padding: 0 2.1vw; //20px;
  ${(props) =>
    window.scrollY === 0
      ? css`
          background-image: linear-gradient(
            to bottom,
            rgba(0, 0, 0, 0.7) 10%,
            rgba(0, 0, 0, 0)
          );
        `
      : !props.scrollUp
      ? css`
          background-color: #000;
        `
      : !props.scrollUp &&
        css`
          background-color: #000;
        `};
  transition: background-color 0.7s, opacity 0.3s;
`;

export default StyledDesktopHeader;
